"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Report extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'report';
        this._name = initParams.name;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._groupIds = (0, util_1.camelArray)(initParams.group_ids);
        this._frequency = initParams.frequency;
        this._includeMegaPdf = initParams.include_mega_pdf;
        this._active = initParams.active;
        this._recipients = (0, util_1.camelArray)(initParams.recipients);
        this._repeatOn = initParams.repeat_on;
        this._perDevice = initParams.per_device;
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateReport(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set assetIds(value) {
        console.error('Do not set objects this way');
    }
    setAssetIds(value) {
        return this.dataService.updateReport(this.id, { asset_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get assetIds() {
        return this._assetIds;
    }
    set siteIds(value) {
        console.error('Do not set objects this way');
    }
    setSiteIds(value) {
        return this.dataService.updateReport(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get siteIds() {
        return this._siteIds;
    }
    set groupIds(value) {
        console.error('Do not set objects this way');
    }
    setGroupIds(value) {
        return this.dataService.updateReport(this.id, { group_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get groupIds() {
        return this._groupIds;
    }
    set frequency(value) {
        console.error('Do not set objects this way');
    }
    setFrequency(value) {
        return this.dataService.updateReport(this.id, { frequency: value }, this);
    }
    get frequency() {
        return this._frequency;
    }
    set includeMegaPdf(value) {
        console.error('Do not set objects this way');
    }
    setIncludeMegaPdf(value) {
        return this.dataService.updateReport(this.id, { include_mega_pdf: value }, this);
    }
    get includeMegaPdf() {
        return this._includeMegaPdf;
    }
    set active(value) {
        console.error('Do not set objects this way');
    }
    setActive(value) {
        return this.dataService.updateReport(this.id, { active: value }, this);
    }
    get active() {
        return this._active;
    }
    set recipients(value) {
        console.error('Do not set objects this way');
    }
    setRecipients(value) {
        return this.dataService.updateReport(this.id, { recipients: (0, util_1.snakeArray)(value) }, this);
    }
    get recipients() {
        return this._recipients;
    }
    set repeatOn(value) {
        console.error('Do not set objects this way');
    }
    setRepeatOn(value) {
        return this.dataService.updateReport(this.id, { repeat_on: value }, this);
    }
    get repeatOn() {
        return this._repeatOn;
    }
    set perDevice(value) {
        console.error('Do not set objects this way');
    }
    setPerDevice(value) {
        return this.dataService.updateReport(this.id, { per_device: value }, this);
    }
    get perDevice() {
        return this._perDevice;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateReport(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateReport(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteReport(this.id, this);
    }
}
exports.default = Report;
//# sourceMappingURL=report.js.map